import React from 'react';
import styled from 'styled-components';
import { getColorToState } from 'utils/pos';

const PelletContainer = styled.div<{
  color?: string;
  value?: string;
  square?: boolean;
  size?: string;
}>`
  width: ${(props) => (props.size ? props.size : '7px')};
  height: ${(props) => (props.size ? props.size : '7px')};
  border-radius: ${(props) => (props.square ? '0px' : '50%')};
  background-color: ${(props) => props.color};
`;

type PelletProps = {
  color?: string;
  value?: string;
  square?: boolean;
  size?: string;
};

const Pellet = ({ color, value, square, size }: PelletProps) => {
  if (!color) {
    color = getColorToState(value || null);
  }

  return (
    <PelletContainer color={color} value={value} square={square} size={size} />
  );
};

export default Pellet;
